import React, { useEffect, useState, useContext } from "react";
import { Collapse } from "antd";
import { AmenitiesWrapper } from "./AmenitiesWrapper";
import openkit from "openkit";
import { AppContext } from "../../../../context";

const Amenities = ({ amenities }) => {
  const [amenitiesGroups, setAmenitiesGroups] = useState([]);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const { Panel } = Collapse;
  const info = useContext(AppContext);

  // const amenitiesList = [
  //   { value: "roupeiro", text: "Roupeiro ou closet" },
  //   {
  //     value: "piso_madeira",
  //     text: "Piso em madeira ou parquet",
  //   },
  //   { value: "ar_condicionado", text: "Ar condicionado" },
  //   { value: "aquecimento", text: "Aquecimento" },
  //   { value: "ventoinha", text: "Ventoinha" },
  //   { value: "televisão", text: "Televisão" },
  //   { value: "canais_por_cabo", text: "Canais por cabo" },
  //   { value: "tomada_perto_cama", text: "Tomada perto da cama" },
  //   { value: "suporte_cabides", text: "Suporte para cabides" },
  //   { value: "frigorifico", text: "Frigorífico" },
  //   { value: "placa_fogao", text: "Placa de fogão" },
  //   { value: "micro_ondas", text: "Micro-ondas" },
  //   { value: "ferro_engomar", text: "Ferro de engomar" },
  //   { value: "maquina_cafe", text: "Máquina de café" },
  //   { value: "chaleira_electrica", text: "Chaleira elétrica" },
  //   { value: "terraco", text: "Terraço" },
  //   { value: "mobiliario_exterior", text: "Mobiliário de exterior" },
  //   { value: "area_estar", text: "Área de estar" },
  //   { value: "area_refeicoes", text: "Área de refeições" },
  //   { value: "patio", text: "Pátio" },
  //   {
  //     value: "engomadoria",
  //     text: "Comodidades de engomadoria",
  //   },
  //   { value: "cadeira_alta_bebes", text: "Cadeira alta para bebés" },
  // ];

  const getText = (value) => {
    return amenitiesList.find((element) => element.value === value)?.text;
  };

  useEffect(() => {
    console.log(amenities);
    // get all amenities
    (async () => {
      const allAmenities = await openkit.data.find("room_amenities");
      console.log("allAmenities", allAmenities);
      const allAmenitiesInCurrentLanguage = allAmenities.map((a) => ({
        value: a.value,
        text: a.name[info.language],
      }));
      setAmenitiesList(allAmenitiesInCurrentLanguage);
    })();

    // break amenities into groups of 5
    if (!amenities || amenities?.length === 0) return;
    let amenitiesGroups = [];
    let amenitiesIn5 = [];
    let j = 0;
    for (let i = 0; i < amenities.length; i++) {
      amenitiesIn5[j] = amenities[i];
      j++;
      if (j === 5 || i === amenities.length - 1) {
        amenitiesGroups.push(amenitiesIn5);
        amenitiesIn5 = [];
        j = 0;
      }
    }
    setAmenitiesGroups(amenitiesGroups);
  }, [amenities]);

  return (
    <>
      <AmenitiesWrapper>
        <Collapse defaultActiveKey={["1"]} style={{ width: "100%" }}>
          <Panel header={info.t("amenities")} key="1">
            {amenitiesGroups.length > 0 && (
              <div>
                <div>
                  {amenitiesGroups[0].length > 0 &&
                    amenitiesGroups[0].map((element, i) => (
                      <p key={"a" + i}>{getText(element)}</p>
                    ))}
                </div>
                <div>
                  {amenitiesGroups[1]?.length > 0 &&
                    amenitiesGroups[1].map((element, i) => (
                      <p key={"b" + i}>{getText(element)}</p>
                    ))}
                </div>
              </div>
            )}
          </Panel>
          {amenitiesGroups.length > 2 && (
            <Panel header="Outras" key="2">
              {amenitiesGroups.map(
                (element, i) =>
                  i > 1 &&
                  amenitiesGroups[i].length > 0 && (
                    <div>
                      {amenitiesGroups[i].map((element, i) => (
                        <p key={"c" + i}>{getText(element)}</p>
                      ))}
                    </div>
                  )
              )}
            </Panel>
          )}
        </Collapse>
      </AmenitiesWrapper>
    </>
  );
};

export default Amenities;
